(ns teamoesterreich.admin-mode.component.ws-event-sync-component
  (:require
    [goog.date.DateTime]
    [reagent.core :as r]
    [reagent-material-ui.components :as mui]
    [teamoesterreich.util.log :as log]
    [teamoesterreich.view-state :as v-state]
    [reagent-material-ui.icons.link-off :refer [link-off]]
    [reagent-material-ui.icons.link :refer [link]]
    [reagent-material-ui.icons.refresh :refer [refresh]]))


(defn loading-animation [!loaded?]
  [:div {:style {:display (if @!loaded? "none" "block")}}
   [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 40}]
   [mui/typography {} "Lade Daten ... "]
   ])

(def !st (r/atom {:is-loading false :last-time 0}))

(defn- ws-event-reload_ [!loaded? listen-entity & [listen-entity-uuid !lock]]
  (let [
        !last-time (r/cursor !st [:last-time])
        !is-loading (r/cursor !st [:is-loading])
        !ws-event-active (r/cursor v-state/ws-state [:ws-active])
        !ws-event-cursor (r/cursor v-state/ws-state [:ws-event listen-entity])

        !last-uuid (r/cursor !ws-event-cursor [:last-uuid])
        ]
    (fn []
      (let [{:keys [time last-uuid]} @!ws-event-cursor
            time (if time (.getTime time) (or @!last-time 0))
            last-time (or @!last-time 0)
            ]
        (log/debug "ws-event-reload " listen-entity last-uuid " time:" time last-time "(" @!last-time ")")
        (when (and
                (not (and !lock @!lock))
                (not= time last-time)
                (or (= listen-entity-uuid last-uuid)))

          (log/debug "ws-event-reload " listen-entity "/" listen-entity-uuid " time " time @!last-time)
          (swap! !st assoc :is-loading true :last-time time)

          (js/setTimeout #(reset! !is-loading false) 1000)
          ;debounce

          ;reload callback
          (reset! !loaded? false))

        [:span {:data-last-time   (str @!last-time)
                :data-entity-uuid (str listen-entity-uuid)
                :style            {:float "right" :margin "3px 3px 0 0"}}
         ;(str time " !== " @!last-time " -- " last-uuid " !== " listen-entity-uuid)
         (if (false? @!ws-event-active)
           [mui/tooltip {:title "automatisches Update deaktiviert"} [link-off {:style {:color "grey" :margin-right "5px"} :onClick #(reset! !ws-event-active true)}]]
           [mui/tooltip {:title "automatisches Update aktiviert"} [link {:style {:color "grey" :margin-right "5px"} :onClick #(reset! !ws-event-active false)}]])

         [refresh {:style   {:color       (if (or (not @!loaded?) @!is-loading) "red" "black")
                             :marginRight "10px"}
                   :onClick #(reset! !loaded? false)}]
         ]))))


(defn ws-event-reload [!loaded? listen-entity & [listen-entity-uuid !lock]]
  (ws-event-reload_ !loaded? listen-entity listen-entity-uuid !lock))







